import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import { ICostUnitContributionMargin } from '../../../models/cost-unit-contribution-margin';
import { ICostUnitCost } from '../../../models/cost-unit-cost.model';
import { ICostUnitCostingLevelCost } from '../../../models/cost-unit-costing-level-cost.model';
import { CostAccountingResource } from '../../../resources/cost-accounting.resource';
import { ICostUnitCostState } from './cost-unit-cost-state.model';

let _state: ICostUnitCostState = {
    costUnitCostingLevelCost: [],
    costUnitCostingLevelCostMap: {},
    isLoading: false,
};

@Injectable({
    providedIn: 'root',
})
export class CostUnitCostFacade {
    protected store$: BehaviorSubject<ICostUnitCostState> = new BehaviorSubject<ICostUnitCostState>(_state);


    constructor(private myCostAccountingResource: CostAccountingResource) {
    }

    public subState(): Observable<ICostUnitCostState> {
        return this.store$.asObservable();
    }

    public clearState(): void {
        this.updateState({
            costUnitCostingLevelCostMap: {},
            isLoading: false,
            costUnitCostingLevelCost: [],
        });
    }

    public async fetchCostUnitCostingLevelCost(costAccountingId: number, costUnitId: number): Promise<void> {
        this.setIsloading(true);
        const costUnitCostingLevelCost: ICostUnitCostingLevelCost[] = await firstValueFrom(
            this.myCostAccountingResource.getCostUnitCostingLevelCost(costAccountingId, costUnitId)).catch(() => []);

        const costUnitCostingLevelCostMap: Record<number, ICostUnitCostingLevelCost> = {};
        for (const cost of costUnitCostingLevelCost) {
            costUnitCostingLevelCostMap[ cost.costingLevelId ] = cost;
        }

        this.updateState({ ..._state, isLoading: false, costUnitCostingLevelCost, costUnitCostingLevelCostMap });
    }

    public async getCostUnitCostList(costAccountingId: number, costingLevelId: number, measureUnit: number): Promise<ICostUnitCost[]> {
        this.setIsloading(true);
        const costList: ICostUnitCost[] = await firstValueFrom(this.myCostAccountingResource.getCostUnitCostList(costAccountingId, costingLevelId, 20, measureUnit)).catch(() => []);
        this.setIsloading(false);
        return costList;
    }

    public async getBreakEvenComparison(costAccountingId: number): Promise<ICostUnitContributionMargin[]> {
        this.setIsloading(true);
        const costList = await firstValueFrom(this.myCostAccountingResource.getCostUnitContributionMargins(costAccountingId)).catch(() => []);
        this.setIsloading(false);
        return costList;
    }

    private setIsloading(isLoading: boolean): void {
        this.updateState({ ..._state, isLoading });
    }

    private updateState(state: ICostUnitCostState): void {
        this.store$.next(_state = state);
    }
}
